"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _FilmStrip = _interopRequireDefault(require("./FilmStrip"));
function cov_16s55kljyr() {
  var path = "/codebuild/output/src659801953/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/FilmStrip/lib/index.js";
  var hash = "a9d15f61ed678aa65b92fe646219a459abbd2b90";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src659801953/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/FilmStrip/lib/index.js",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a9d15f61ed678aa65b92fe646219a459abbd2b90"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_16s55kljyr = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_16s55kljyr();
var _default = exports.default = _FilmStrip.default;